import React, { useState, useEffect } from 'react';
import './NumberMeanings.css';
import { auth, getUserData } from '../firebase';

const singleDigitMeanings = {
  '0': 'Phủ định',
  '1': 'Nghề nghiệp',
  '2': 'Lo lắng',
  '3': 'Bất đồng',
  '4': 'Tình cảm',
  '5': 'Vận rủi',
  '6': 'Cơ hội',
  '7': 'Xung đột',
  '8': 'Giữ tiền',
  '9': 'Khuếch đại'
};

const digitPairMeanings = {
  '00': 'Phủ định',
  '01': 'Nghề nghiệp',
  '02': 'Lo lắng',
  '03': 'Bất đồng',
  '04': 'Tình cảm',
  '05': 'Vận rủi',
  '06': 'Cơ hội',
  '07': 'Xung đột',
  '08': 'Giữ tiền',
  '09': 'Khuếch đại',
  '10': 'Không tốt',
  '11': 'Hai việc',
  '12': 'Lập nghiệp',
  '13': 'Khôn khéo',
  '14': 'Hướng thượng',
  '15': 'Vận rủi',
  '16': 'Trắc trở',
  '17': 'Trực tính',
  '18': 'Sinh tiền',
  '19': 'Lãnh đạo',
  '20': 'Mất mát',
  '21': 'Lanh lợi',
  '22': 'Giỏi giang',
  '23': 'Nhiệt tình',
  '24': 'Lo lắng (tình cảm)',
  '25': 'Kỹ tiền',
  '26': 'Tiết kiệm',
  '27': 'Đảm đang (Nam giới)',
  '28': 'Có tiền (lo âu)',
  '29': 'Vượt lên',
  '30': 'Thua thiệt',
  '31': 'Sụp đổ',
  '32': 'Duyên dáng',
  '33': 'Lãnh đạo',
  '34': 'Xung đột (tình cảm)',
  '35': 'Rối bời',
  '36': 'Đào hoa',
  '37': 'Phản bội',
  '38': 'Tai qua',
  '39': 'Bạc đãi',
  '40': 'Cô độc',
  '41': 'Thuyết phục',
  '42': 'Yêu thương',
  '43': 'Áp bức',
  '44': 'Lãng mạn',
  '45': 'Trắc trở (tình duyên)',
  '46': 'Ngưỡng mộ',
  '47': 'Chia tay',
  '48': 'Được tiền',
  '49': 'Bất hòa',
  '50': 'Nợ nần',
  '51': 'Trở ngại',
  '52': 'Giận hờn',
  '53': 'Liên lụy',
  '54': 'Tai ương',
  '55': 'Nguyên tắc',
  '56': 'Hậu kiết',
  '57': 'Chỉ trích',
  '58': 'Hao tiền',
  '59': 'Vận rủi',
  '60': 'Vụt mất',
  '61': 'Cơ hội (nghề nghiệp)',
  '62': 'Di chuyển',
  '63': 'Hướng thiện',
  '64': 'Học vấn',
  '65': 'Hậu hung',
  '66': 'Giữ tốt',
  '67': 'Nói nhiều',
  '68': 'Giữ tiền',
  '69': 'Lệ thuộc',
  '70': 'Nhẫn nhịn',
  '71': 'Ra đi',
  '72': 'Buồn phiền',
  '73': 'Chỉ trích (vị thế)',
  '74': 'Chia tay',
  '75': 'Lo tiền',
  '76': 'Bảo thủ',
  '77': 'Cộc tính',
  '78': 'Hao tiền',
  '79': 'Bất đồng (gia đình)',
  '80': 'Mất mát',
  '81': 'Vu khống',
  '82': 'Thẳng thắn',
  '83': 'Quyền lực',
  '84': 'Yêu thương',
  '85': 'Hao tiền',
  '86': 'Giữ tiền',
  '87': 'Hao tiền',
  '88': 'Ban đầu xấu',
  '89': 'Hưởng đức',
  '90': 'Vụt mất',
  '91': 'Thăng tiến',
  '92': 'Lãnh đạo (chống đối)',
  '93': 'Lãnh đạo (chống đối)',
  '94': 'Ngưỡng mộ',
  '95': 'Tai nạn',
  '96': 'Cực lớn (cơ hội)',
  '97': 'Xung đột',
  '98': 'Rất giàu',
  '99': 'Tham vọng'
};

const getMeaningStyle = (meaning) => {
  const style = {
    padding: '0.75rem',
    textAlign: 'center',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    lineHeight: 1.4,
    color: '#000',
    fontWeight: 500,
    backgroundColor: '#f5f5f5',
    transition: 'background-color 0.3s ease, color 0.3s ease'
  };

  // Color categories
  const negativeNumbers = ['0', '2', '3', '5', '7', '10', '15', '16', '20', '24', '28', '30', '31', '34', '35', '37', '38', '39', '40', '43', '45', '47', '49', '50', '51', '52', '53', '54', '57', '58', '59', '60', '65', '67', '69', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '85', '87', '88', '90', '95', '97'];
  const positiveNumbers = ['4', '6', '12', '13', '14', '17', '18', '19', '21', '22', '23', '26', '27', '29', '32', '33', '36', '41', '42', '44', '46', '48', '55', '56', '61', '62', '63', '64', '66', '70', '82', '83', '84', '89', '91', '92', '93', '94', '96', '98', '99'];
  const neutralNumbers = ['8', '9', '11', '25', '68', '86'];

  // Meaning categories
  const emotionsNegative = ['0', '2', '10', '20', '30', '31', '35', '39', '40', '43', '52', '57', '65', '67', '69', '72', '73', '76', '77', '81', '88', '95'];
  const positiveTraits = ['13', '14', '17', '21', '22', '23', '27', '29', '32', '41', '55', '56', '63', '66', '70', '82', '89'];
  const financial = ['8', '18', '25', '26', '28', '48', '50', '58', '68', '75', '78', '85', '86', '87', '98'];
  const careerOpportunities = ['1', '6', '12', '61', '62', '64', '91', '96'];
  const leadershipPower = ['19', '33', '83', '92', '93', '99'];
  const relationships = ['4', '24', '34', '36', '37', '42', '44', '45', '46', '47', '71', '74', '84', '94'];
  const risksObstacles = ['5', '15', '16', '38', '51', '53', '54', '59', '60', '80', '90'];
  const conflictsDisagreements = ['3', '7', '49', '79', '97'];
  const others = ['9', '11'];

  // Get the number from the meaning
  const number = Object.entries({...singleDigitMeanings, ...digitPairMeanings})
    .find(([key, value]) => value === meaning)?.[0];

  if (number) {
    let backgroundColor;
    if (negativeNumbers.includes(number)) {
      backgroundColor = '#ea4236';
    } else if (positiveNumbers.includes(number)) {
      backgroundColor = '#33a854';
    } else if (neutralNumbers.includes(number)) {
      backgroundColor = '#efb11e';
    }

    let label = 'Khác';
    if (emotionsNegative.includes(number)) {
      label = 'Cảm xúc/Tiêu cực';
    } else if (positiveTraits.includes(number)) {
      label = 'Tính cách/Tố chất tích cực';
    } else if (financial.includes(number)) {
      label = 'Tài chính';
    } else if (careerOpportunities.includes(number)) {
      label = 'Nghề nghiệp/Cơ hội';
    } else if (leadershipPower.includes(number)) {
      label = 'Lãnh đạo/Quyền lực';
    } else if (relationships.includes(number)) {
      label = 'Mối quan hệ/Tình cảm';
    } else if (risksObstacles.includes(number)) {
      label = 'Rủi ro/Trở ngại';
    } else if (conflictsDisagreements.includes(number)) {
      label = 'Xung đột/Bất đồng';
    } else if (others.includes(number)) {
      label = 'Khác';
    }

    return { ...style, backgroundColor, label };
  }

  return { ...style, label: 'Khác' };
};

const NumberMeanings = ({ phoneNumber, showSingleDigits = false }) => {
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if (user) {
        const userData = await getUserData(user.uid);
        // Show component if user has admin role
        setShowComponent(userData?.role === 'admin');
      } else {
        setShowComponent(false);
      }
    });
    return () => unsubscribe();
  }, []);

  if (!showComponent) return null;
  const digits = phoneNumber.split('');
  const pairs = [];
  
  for (let i = 0; i < digits.length; i += 2) {
    pairs.push(digits[i] + digits[i + 1]);
  }

  const totalSum = digits.reduce((sum, digit) => sum + parseInt(digit), 0);
  const totalSumMeaning = digitPairMeanings[totalSum.toString()] || 'Chưa có dữ liệu';

  return (
    <section className="number-meanings-section">
      <h2 className="section-title">🔢 Thông Tin Chữ Số {phoneNumber}</h2>
      
      <div className="number-meanings-container">
        {showSingleDigits && (
          <div className="single-digits">
            <h3>Ý Nghĩa Từng Số</h3>
            <div className="digits-grid">
              {digits.map((digit, index) => (
                <div key={index} className="number-cell">
                  <div className="number-part">{digit}</div>
                  <div style={getMeaningStyle(singleDigitMeanings[digit])}>
                    <span className="meaning-category">{getMeaningStyle(singleDigitMeanings[digit]).label}</span>
                    <span className="meaning-text">{singleDigitMeanings[digit]}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="digit-pairs">
          <h3>Ý Nghĩa Cặp Số</h3>
          <div className="pairs-grid">
            {pairs.map((pair, index) => (
              <div key={index} className="number-cell">
                <div className="number-part">{pair}</div>
                <div style={getMeaningStyle(digitPairMeanings[pair])}>
                  <span className="meaning-category">{getMeaningStyle(digitPairMeanings[pair]).label}</span>
                  <span className="meaning-text">{digitPairMeanings[pair]}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="digit-total">
          <h3>Tổng Số</h3>
          <div className="total-grid">
            <div className="number-cell">
              <div className="number-part">{totalSum}</div>
              <div style={getMeaningStyle(totalSumMeaning)}>
                <span className="meaning-category">{getMeaningStyle(totalSumMeaning).label}</span>
                <span className="meaning-text">{totalSumMeaning}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NumberMeanings;